import { render, staticRenderFns } from "./RouterFrame.vue?vue&type=template&id=bdd46bc6&"
import script from "./RouterFrame.vue?vue&type=script&lang=js&"
export * from "./RouterFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports